import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const InfoMuroCarbonDeBambu = () => {
  return (
    <section>
      <div className="container">
        <div className="row g-xxl-5 align-items-end mt-n1-9">
          <div className="col-lg-6 order-2 order-lg-1 mt-1-9">
            <div className="pe-lg-1-6 pe-xl-6">
              <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-bamboo-espejo/muro-bamboo-espejo-caracteristicas-2.jpg`} alt="Resistente al agua y moho carbono de bambu" className="mb-6 mb-xl-10" />
              <div className="ps-lg-10 ps-xl-20">
                <div className="d-flex border-bottom pb-1-9 mb-1-9">
                  <div className="flex-shrink-0 me-4">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/icons/icon-39.png`} alt="icono" />
                  </div>
                  <div className="flex-grow-1">
                    <h4 className="h5">Dónde se puede instalar</h4>
                    <p className="mb-0">
                    En decoración interior de techos y paredes para hoteles, villas, restaurantes, galerías,
                    oficinas, espacios comerciales, etc.
                    </p>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-4">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/icons/icon-29.png`} alt="icono" />
                  </div>
                  <div className="flex-grow-1">
                    <h4 className="h5">Resistente al agua y moho</h4>
                    <p className="mb-0">
                    Resistente al agua y muy resistente al moho y los hongos, por sus propiedades se adaptan al clima húmedo mantenimiento perfectamente su estado.
                    </p>
                  </div>
                </div>
                <div className="w-xl-100 w-xxl-100 mb-6">
                  <BannerNoInstalacion />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 mt-1-9">
            <div className="ps-lg-1-6 ps-xl-6">
              <div className="title-style1 mb-1-9 mb-lg-10 mb-xl-15">
                <span>Placa de PVC Tipo Espejo</span>
                <h2 className="h1 mb-4">Características</h2>
                <p className="mb-0">
                Alta resistencia, dureza, antideslizante y resistente al desgaste; no es fácil de romper, baja absorción de agua, resistencia a la corrosión; radiación antiestática, aislamiento, poco aislamiento térmico, retardante de llama
                Ancho: 1,22m<br></br>
                Longitud: 2.80M<br></br>
                Grosor: 5mm<br></br>
                </p>
              </div>
              <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-bamboo-espejo/muro-bamboo-espejo-caracteristicas.jpg`} alt="Muro de carbono de bambú" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoMuroCarbonDeBambu;